export function isNonEmpty(x: any): boolean {
    return (
        typeof x !== 'undefined' &&
        x !== null &&
        (!Array.isArray(x) || x.length > 0) &&
        (typeof x !== 'string' || x !== '')
    )
}

export type StringDict = Record<string, string>

export type SingleSelection = string|number|null;
export type MultiSelection = string[];
export function isMultiSelection(x: any): x is MultiSelection {
    return (
        Array.isArray(x) &&
        (x.length === 0 || typeof x[0] === 'string')
    )
}

/**
 * A filter choice. */
export interface Choice {
    id: string;
    label: string;
}


export type MinMaxSelection = [number|null, number|null];
export function isMinMaxSelection(x: any): x is MinMaxSelection {
    return (
        Array.isArray(x) &&
        x.length === 2 &&
        (typeof x[0] === 'number' || x[0] === null) &&
        (typeof x[1] === 'number' || x[1] === null)
    )
}

export interface MinMaxOption {
    num: number;
    name: string;
    disabled: boolean;
}

/**
 * @type Type representing a filter selection */
export type AnySelection = SingleSelection|MultiSelection|MinMaxSelection;

/**
 * @type Record of selections indexed by a string */
export type SelectionRecord = Record<string, AnySelection>;






export interface SingleFilter {
    name: string;
    label: string;
    type: string;
    unit: string;
    choices: Choice[];
}

export type MultiFilter = SingleFilter;

export interface MinMaxFilter {
    name: string;
    label: string;
    type: string;
    unit: string;
    range: [number, number];
    places: number|undefined;
    step: number|undefined;
}

export type AnyFilter = SingleFilter | MultiFilter | MinMaxFilter;

/* MODEL TYPES */
/* --- */

export interface Breadcrumb {
    categories: string[];
    path: string;
    name: string;
    last: boolean;
}

export interface Catalog {
    id: string;
    name: string;
}

export interface Promo {
    id: number;
    title: string;
    teaser: string;
    url: string;
    img: string;
    date_valid: string;
    date_expires: string;
}

export interface Card {
    name: string;
    url: string;
    type: string;
    img: string;
    details: CardDetail[];
    brand: string;
    category: number; // can we link this to our category objects?
    specs: Record<string, number|string|null>;
    promo: boolean;
}

export interface CardDetail {
    name: string;
    value: string;
}

export interface Category {
    id: string;
    name: string;
    description: string;
    img: string;
    url: string;
    promo: boolean;
}

export interface Banner {
    title: string;
    description: string;
    img: string;
    imgB: string;
}

export type UpdateBannerFunc = (banner: Banner) => void;
